import React from 'react';
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button, FormText } from "reactstrap";
import Select from 'react-select';

export const FormDilutionCreate = (props) => {
    const {
        methodAction,handleSearchWSSDilutions,handleUpdateDilutions,saveUpdateDilutions,handleDeleteDilutions,
        saveDeleteDilutions,validarFormDilutions,handleCreateDilutions,saveCreateDilutions,
        formValuesDilutions, handleInputChangeDilutions, handleUpdateValuesDilutions, handleSelectValuesDilutions,
        validacionesDilutions,loading,catwsprocess,button
    } = props;

    const {
        name_ws_valid,
        id_type_sample_valid,
        list_determinations_valid
    } = validacionesDilutions
    return (
        <Form className='' role="form" onSubmit={methodAction}>
            <ModalBody>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label className='col-form-label'>NOMBRE DE LA DILUCIÓN <span className='f-16' style={{ color: "#0079C7" }}>*</span>:</Label>
                            <Input
                                className='form-control form-control-sm input-air-primary'
                                type='text'
                                name="name_dilution"
                                value={formValuesDilutions.name_dilution}
                                onChange={handleInputChangeDilutions}
                                autoComplete="off"
                            />
                            <FormFeedback>Minimo 3 caracteres</FormFeedback>
                        </FormGroup>
                    </Col>

                    <Col sm="12">
                        <Label className='col-form-label'>PROCESO:</Label>
                        <FormGroup>
                            <select
                                className="form-control form-control-sm input-air-primary"
                                name="id_process_config_dilution"
                                value={formValuesDilutions.id_process_config_dilution}
                                onChange={handleInputChangeDilutions}
                            >
                                <option value={0}>Selecciona un proceso</option>
                                {
                                    catwsprocess.map(element => (
                                        <option key={element.id_process_config} value={element.id_process_config}>
                                            {element.name}
                                        </option>
                                    ))
                                }
                            </select>
                            <FormFeedback>Selecciones mínimo un proceso</FormFeedback>
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button outline color="primary" type="submit" size='sm' className={loading ? "disabled progress-bar-animated progresss-bar-striped" : ""}>
                {button}
                </Button>
                <Button size="sm" outline color='danger' type='button'>
                    Cancelar
                </Button>
            </ModalFooter>
        </Form>
    )
}